import { TradeConditionsSymbol } from '@/api/trade-conditions/types';
import { getColDef } from '@/blocks/components/DataGrid';
import { FormatPercent, FormatPrice } from '@/blocks/formatters';
import { extractNumber, getDecimalPlaceCount } from '@/utils/number';

export const getColDefTradingFee = (headerName: string) =>
  getColDef<TradeConditionsSymbol>(
    'tradingFee',
    headerName,
    (params) => {
      return (
        <FormatPercent
          value={extractNumber(params.row.tradingFee)}
          fraction={{ max: getDecimalPlaceCount(params.row.tradingFee) }}
        />
      );
    },
    {
      flex: 1,
      minWidth: 150,
    },
  );

export const getColDefMinOrderSize = (headerName: string) =>
  getColDef<TradeConditionsSymbol>(
    'minOrderSize',
    headerName,
    (params) => {
      return (
        <FormatPrice
          price={extractNumber(params.row?.minOrderSize)}
          displaySymbol
          currency={params.row?._orderSizeUnit}
          priceScale={getDecimalPlaceCount(params.row?.minOrderSize)}
        />
      );
    },
    {
      flex: 1,
      minWidth: 200,
    },
  );

export const getColDefFinancingLong = (headerName: string) =>
  getColDef<TradeConditionsSymbol>(
    'financingLongPct',
    headerName,
    (params) => {
      return (
        <FormatPercent
          value={extractNumber(params.row.financingLongPct)}
          fraction={{ max: getDecimalPlaceCount(params.row.financingLongPct) }}
        />
      );
    },
    {
      flex: 1,
      minWidth: 200,
    },
  );

export const getColDefFinancingShort = (headerName: string) =>
  getColDef<TradeConditionsSymbol>(
    'financingShortPct',
    headerName,
    (params) => {
      return (
        <FormatPercent
          value={extractNumber(params.row.financingShortPct)}
          fraction={{ max: getDecimalPlaceCount(params.row.financingShortPct) }}
        />
      );
    },
    {
      flex: 1,
      minWidth: 200,
    },
  );

export const getColDefMakerFee = (headerName: string) =>
  getColDef<TradeConditionsSymbol>(
    'makerFeePct',
    headerName,
    (params) => {
      return (
        <FormatPercent
          value={extractNumber(params.row.makerFeePct)}
          fraction={{ max: getDecimalPlaceCount(params.row.makerFeePct) }}
        />
      );
    },
    {
      flex: 1,
      minWidth: 150,
    },
  );

export const getColDefTakerFee = (headerName: string) =>
  getColDef<TradeConditionsSymbol>(
    'takerFeePct',
    headerName,
    (params) => {
      return (
        <FormatPercent
          value={extractNumber(params.row.takerFeePct)}
          fraction={{ max: getDecimalPlaceCount(params.row.takerFeePct) }}
        />
      );
    },
    {
      flex: 1,
      minWidth: 150,
    },
  );
